function getRejectOpinionKey(type, row) {
  return `${type}:${row && row.id ? row.id : ''}`
}

function normalizeOpinion(value) {
  return String(value || '').trim()
}

function mapRejectRows(rows, type, opinions) {
  return (rows || []).map((row) => ({
    item_id: row.id,
    opinion: normalizeOpinion(opinions[getRejectOpinionKey(type, row)]),
    type,
    name: row.name || '',
  }))
}

function buildRejectItems(selectedInfos, selectedFiles, opinions) {
  return mapRejectRows(selectedInfos, 'info', opinions || {})
    .concat(mapRejectRows(selectedFiles, 'file', opinions || {}))
}

function validateRejectItems(selectedInfos, selectedFiles, opinions) {
  const items = buildRejectItems(selectedInfos, selectedFiles, opinions)
  if (items.length === 0) {
    return {
      valid: false,
      message: '请至少勾选一项需要修改的材料',
      items,
    }
  }
  const missing = items.find((item) => item.type === 'info' && !item.opinion)
  if (missing) {
    return {
      valid: false,
      message: `请填写${missing.name || '已勾选项'}的修改意见`,
      items,
    }
  }
  return {
    valid: true,
    message: '',
    items,
  }
}

module.exports = {
  buildRejectItems,
  getRejectOpinionKey,
  validateRejectItems,
}
